module.exports = "../../app/cells/pages/questions/question_counter_cell.rb";